import type { IApplicationState } from 'shared/types/redux';

export const selectCPDModalType = (state: IApplicationState) => state.cpd.modalType;
